import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorAccountUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.account.update),
			switchMap((action) =>
				this.vendorAdminService.accountUpdateAndThrow(action.vendor).pipe(
					map(() => VendorActions.account.updateSuccess()),
					catchError((error) =>
						of(VendorActions.account.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	updateProductFiles = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.account.updateProductFiles),
			switchMap((action) =>
				this.vendorService.updateProductFiles(action.files ?? [], action.fileRecords).pipe(
					map(() => VendorActions.account.updateProductFilesSuccess()),
					catchError((error) =>
						of(VendorActions.account.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorService: VendorService,
		private vendorAdminService: VendorAdminService
	) {}
}
